export default "__VITE_ASSET__CgZk0_1U__"